var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmarkLarge = function SvgCheckmarkLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.311 44.426 0 29.269l4.181-4.182 11.499 9.408L47.039 0l4.181 2.09-30.487 41.917a4.18 4.18 0 0 1-6.422.419ZM61.673 14.634h-8.362a1.045 1.045 0 0 1 0-2.09h8.362a1.046 1.046 0 0 1 0 2.09ZM61.673 25.087h-15.68a1.046 1.046 0 1 1 0-2.09h15.68a1.045 1.045 0 0 1 0 2.09ZM61.673 35.54H38.676a1.045 1.045 0 1 1 0-2.09h22.997a1.045 1.045 0 0 1 0 2.09ZM61.673 45.993H31.36a1.045 1.045 0 1 1 0-2.09h30.314a1.045 1.045 0 1 1 0 2.09Z",
    fill: "#19336E"
  })));
};
export default SvgCheckmarkLarge;